// extracted by mini-css-extract-plugin
export default {"blockwrapper":"WO","header":"XO","name":"YO","columns":"ZO","imagewrapper":"aP","addinfo":"bP","description":"cP","price":"eP","old":"fP","new":"gP","desc_d":"hP","infoblock":"iP","desc_m":"jP"};
    if(module.hot) {
      // 1715188237930
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  